import { DaoService } from "./DaoService";

export default class PieceJointeService extends DaoService {
    static CLASS_NAME = 'App\\Models\\PieceJointe';

    // déclare une constante pour les types : organisation,user
    static TYPES = {
        ORGANISATION: 'organisation',
        USER: 'user',
        DOCUMENT: 'document',
        CONTACT: 'contact',
        DOCUMENTEVALUATION:'documentevaluation',
    };

    static getInstance() {
        return super.getInstance('piecejointe');
    }

    findByParent(parentId, parentType) {
        const data = {
            parent_type: parentType,
        };

        return PieceJointeService.post(`${this.prefix}/${parentId}/parent`, data);
    }

    create(data, onUploadProgress) {
        return PieceJointeService.upload(`${this.prefix}`, data, onUploadProgress);
    }
    
    getPreviewUrl(fileId) {
        return PieceJointeService.download(`${this.prefix}/${fileId}`);
    }

    storeFromDrive(data) {
        return PieceJointeService.post(`${this.prefix}/store-from-drive`, data);
    }
}